export const assetList = [
    new URL('/src/_assets/_font/Druk-Heavy.woff2', import.meta.url).href,

    // Audio
    new URL('/_sounds/fast-tribal-drums.mp3', import.meta.url).href,
    new URL('/_sounds/collect.mp3', import.meta.url).href,
    new URL('/_sounds/countdown-ping.mp3', import.meta.url).href,
    new URL('/_sounds/countdown-end.mp3', import.meta.url).href,
    new URL('/_sounds/jump.mp3', import.meta.url).href,
    new URL('/_sounds/roar1.mp3', import.meta.url).href,
    new URL('/_sounds/roar2.mp3', import.meta.url).href,
    new URL('/_sounds/roar3.mp3', import.meta.url).href,
    new URL('/_sounds/roar4.mp3', import.meta.url).href,

    // Textures
    new URL('/_game/float_black.png', import.meta.url).href,
    new URL('/_game/float_wide_black.png', import.meta.url).href,
    new URL('/_game/float_white.png', import.meta.url).href,
    new URL('/_game/float_wide_white.png', import.meta.url).href,
    new URL('/_game/ground_full.png', import.meta.url).href,
    new URL('/_game/ground_c1.png', import.meta.url).href,
    new URL('/_game/ground_c2.png', import.meta.url).href,
    new URL('/_game/ground_c3.png', import.meta.url).href,
    new URL('/_game/item_banana.png', import.meta.url).href,
    new URL('/_game/item_orange.png', import.meta.url).href,
    new URL('/_game/item_apple.png', import.meta.url).href,
    new URL('/_game/item_spoon.png', import.meta.url).href,
    new URL('/_game/item_milk.png', import.meta.url).href,
    new URL('/_game/item_cereal_1.png', import.meta.url).href,
    new URL('/_game/item_cereal_2.png', import.meta.url).href,

    // Traps
    new URL('/_game/traps/trap_cube.png', import.meta.url).href,
    new URL('/_game/traps/trap_knife.png', import.meta.url).href,
    new URL('/_game/traps/trap_milk_start.png', import.meta.url).href,
    new URL('/_game/traps/trap_milk.png', import.meta.url).href,
    new URL('/_game/traps/trap_thorn_bush.png', import.meta.url).href,
    new URL('/_game/traps/trap_thorns.png', import.meta.url).href,

    // Cosmetics
    new URL('/_game/cosmetic/plant1.png', import.meta.url).href,
    new URL('/_game/cosmetic/plant2.png', import.meta.url).href,
    new URL('/_game/cosmetic/plant3.png', import.meta.url).href,
    new URL('/_game/cosmetic/rock1.png', import.meta.url).href,
    new URL('/_game/cosmetic/rock2.png', import.meta.url).href,
    new URL('/_game/cosmetic/rock3.png', import.meta.url).href,
    new URL('/_game/cosmetic/feather1.png', import.meta.url).href,
    new URL('/_game/cosmetic/feather2.png', import.meta.url).href,

    new URL('/_game/boss/endBowl.png', import.meta.url).href,
    new URL('/_game/boss/endSpoon1.png', import.meta.url).href,
    new URL('/_game/boss/endSpoon2.png', import.meta.url).href,
    new URL('/_game/boss/endSpoon3.png', import.meta.url).href,
    new URL('/_game/boss/endSpoon4.png', import.meta.url).href,
    new URL('/_game/boss/endSpoon5.png', import.meta.url).href,
    new URL('/_game/boss/endBlock.png', import.meta.url).href,
    new URL('/_game/boss/endBlockHole.png', import.meta.url).href,
    
    // BG
    new URL('/_game/bg/BG_grass-1.png', import.meta.url).href,
    new URL('/_game/bg/BG_ground.jpg', import.meta.url).href,
    new URL('/_game/bg/BG_mountain-1.png', import.meta.url).href,
    new URL('/_game/bg/BG_mountain-2.png', import.meta.url).href,
    new URL('/_game/bg/BG_tree-1.png', import.meta.url).href,
    new URL('/_game/bg/BG_tree-2.png', import.meta.url).href,
    new URL('/_game/bg/BG_tree-3.png', import.meta.url).href,
];



export const spriteSize: {[id: string]: {x:number, y:number}} = {
    "ground_full": { x:656, y:329 },
    "ground_c1": { x:147, y:492 },
    "ground_c2": { x:185, y:492 },
    "ground_c3": { x:247, y:492 },
    "float_black": { x:139, y:45 },
    "float_white": { x:139, y:52 },
    "float_wide_black": { x:185, y:45 },
    "float_wide_white": { x:185, y:50 },
    "gap": { x:100, y:0 }, // not used don't worry about it
    "plant1": { x:85, y:69 },
    "plant2": { x:62, y:68 },
    "plant3": { x:66, y:70 },
    "rock1": { x:47, y:21 },
    "rock2": { x:29, y:21 },
    "rock3": { x:46, y:17 },
    "item_banana": { x:55, y:54 },
    "item_orange": { x:55, y:55 },
    "item_apple": { x:51, y:51 },
    "item_spoon": { x:55, y:55 },
    "item_milk": { x:35, y:56 },
    "item_cereal_1": { x:64, y:60 },
    "item_cereal_2": { x:64, y:52 },
    "feather1": { x:21, y:77 },
    "feather2": { x:25, y:93 },
    "trap_cube": { x:72, y:72 },
    "trap_milk_start": { x:105, y:357 },
    "trap_milk": { x:80, y:122 },
    "trap_thorn_bush": { x:88, y:88 },
    "trap_thorns": { x:77, y:472 },
    "trap_knife": { x:44, y:516 },
    "endBowl": { x: 117, y: 63},
    "endSpoon1": { x: 51, y: 51},
    "endSpoon2": { x: 51, y: 51},
    "endSpoon3": { x: 51, y: 51},
    "endSpoon4": { x: 51, y: 51},
    "endSpoon5": { x: 51, y: 51},
    "endBlock": { x: 34, y: 34},
    "endBlockHole": { x: 34, y: 34},
    "BG_grass-1": { x: 111, y: 22},
    "BG_ground": { x: 401, y: 572},
    "BG_mountain-1": { x: 309, y: 44},
    "BG_mountain-2": { x: 449, y: 24},
    "BG_tree-1": { x: 72, y: 60},
    "BG_tree-2": { x: 57, y: 62},
    "BG_tree-3": { x: 59, y: 54},
}
export const lionIdles = [
    // ------------------------ [ User Assets ] ---------
    new URL('/src/_assets/_game/_lion/idle/Idle_00000.png', import.meta.url).href,
    new URL('/src/_assets/_game/_lion/idle/Idle_00001.png', import.meta.url).href,
    new URL('/src/_assets/_game/_lion/idle/Idle_00002.png', import.meta.url).href,
    new URL('/src/_assets/_game/_lion/idle/Idle_00003.png', import.meta.url).href,
    new URL('/src/_assets/_game/_lion/idle/Idle_00004.png', import.meta.url).href,
    new URL('/src/_assets/_game/_lion/idle/Idle_00005.png', import.meta.url).href,
    new URL('/src/_assets/_game/_lion/idle/Idle_00006.png', import.meta.url).href,
    new URL('/src/_assets/_game/_lion/idle/Idle_00007.png', import.meta.url).href,
    new URL('/src/_assets/_game/_lion/idle/Idle_00008.png', import.meta.url).href,
    new URL('/src/_assets/_game/_lion/idle/Idle_00009.png', import.meta.url).href,
    new URL('/src/_assets/_game/_lion/idle/Idle_00010.png', import.meta.url).href,
    new URL('/src/_assets/_game/_lion/idle/Idle_00011.png', import.meta.url).href,
    new URL('/src/_assets/_game/_lion/idle/Idle_00012.png', import.meta.url).href,
    new URL('/src/_assets/_game/_lion/idle/Idle_00013.png', import.meta.url).href,
    new URL('/src/_assets/_game/_lion/idle/Idle_00014.png', import.meta.url).href,
    new URL('/src/_assets/_game/_lion/idle/Idle_00015.png', import.meta.url).href,
    new URL('/src/_assets/_game/_lion/idle/Idle_00016.png', import.meta.url).href,
    new URL('/src/_assets/_game/_lion/idle/Idle_00017.png', import.meta.url).href,
    new URL('/src/_assets/_game/_lion/idle/Idle_00018.png', import.meta.url).href,
    new URL('/src/_assets/_game/_lion/idle/Idle_00019.png', import.meta.url).href,
    new URL('/src/_assets/_game/_lion/idle/Idle_00020.png', import.meta.url).href,
    new URL('/src/_assets/_game/_lion/idle/Idle_00021.png', import.meta.url).href,
    new URL('/src/_assets/_game/_lion/idle/Idle_00022.png', import.meta.url).href,
    new URL('/src/_assets/_game/_lion/idle/Idle_00023.png', import.meta.url).href,
    new URL('/src/_assets/_game/_lion/idle/Idle_00024.png', import.meta.url).href,
    new URL('/src/_assets/_game/_lion/idle/Idle_00025.png', import.meta.url).href,
    new URL('/src/_assets/_game/_lion/idle/Idle_00026.png', import.meta.url).href,
    new URL('/src/_assets/_game/_lion/idle/Idle_00027.png', import.meta.url).href,
    new URL('/src/_assets/_game/_lion/idle/Idle_00028.png', import.meta.url).href,
    new URL('/src/_assets/_game/_lion/idle/Idle_00029.png', import.meta.url).href,
    new URL('/src/_assets/_game/_lion/idle/Idle_00030.png', import.meta.url).href,
    new URL('/src/_assets/_game/_lion/idle/Idle_00031.png', import.meta.url).href,
    new URL('/src/_assets/_game/_lion/idle/Idle_00032.png', import.meta.url).href,
    new URL('/src/_assets/_game/_lion/idle/Idle_00033.png', import.meta.url).href,
    new URL('/src/_assets/_game/_lion/idle/Idle_00034.png', import.meta.url).href,
    new URL('/src/_assets/_game/_lion/idle/Idle_00035.png', import.meta.url).href,
    new URL('/src/_assets/_game/_lion/idle/Idle_00036.png', import.meta.url).href,
]

export const lionJump = [
    // ------------------------ [ User Assets ] ---------
    new URL('/src/_assets/_game/_lion/jump/Jump_00000.png', import.meta.url).href,
    new URL('/src/_assets/_game/_lion/jump/Jump_00001.png', import.meta.url).href,
    new URL('/src/_assets/_game/_lion/jump/Jump_00002.png', import.meta.url).href,
    new URL('/src/_assets/_game/_lion/jump/Jump_00003.png', import.meta.url).href,
    new URL('/src/_assets/_game/_lion/jump/Jump_00004.png', import.meta.url).href,
    new URL('/src/_assets/_game/_lion/jump/Jump_00005.png', import.meta.url).href,
    new URL('/src/_assets/_game/_lion/jump/Jump_00006.png', import.meta.url).href,
    new URL('/src/_assets/_game/_lion/jump/Jump_00007.png', import.meta.url).href,
    new URL('/src/_assets/_game/_lion/jump/Jump_00008.png', import.meta.url).href,
    new URL('/src/_assets/_game/_lion/jump/Jump_00009.png', import.meta.url).href,
    new URL('/src/_assets/_game/_lion/jump/Jump_00010.png', import.meta.url).href,
    new URL('/src/_assets/_game/_lion/jump/Jump_00011.png', import.meta.url).href,
    new URL('/src/_assets/_game/_lion/jump/Jump_00012.png', import.meta.url).href,
    new URL('/src/_assets/_game/_lion/jump/Jump_00013.png', import.meta.url).href,
    new URL('/src/_assets/_game/_lion/jump/Jump_00014.png', import.meta.url).href,
    new URL('/src/_assets/_game/_lion/jump/Jump_00015.png', import.meta.url).href,
    new URL('/src/_assets/_game/_lion/jump/Jump_00016.png', import.meta.url).href,
    new URL('/src/_assets/_game/_lion/jump/Jump_00017.png', import.meta.url).href,
    new URL('/src/_assets/_game/_lion/jump/Jump_00018.png', import.meta.url).href,
    new URL('/src/_assets/_game/_lion/jump/Jump_00019.png', import.meta.url).href,
    new URL('/src/_assets/_game/_lion/jump/Jump_00020.png', import.meta.url).href,
    new URL('/src/_assets/_game/_lion/jump/Jump_00021.png', import.meta.url).href,
    new URL('/src/_assets/_game/_lion/jump/Jump_00022.png', import.meta.url).href,
    new URL('/src/_assets/_game/_lion/jump/Jump_00023.png', import.meta.url).href,
    new URL('/src/_assets/_game/_lion/jump/Jump_00024.png', import.meta.url).href,
    new URL('/src/_assets/_game/_lion/jump/Jump_00025.png', import.meta.url).href,
    new URL('/src/_assets/_game/_lion/jump/Jump_00026.png', import.meta.url).href,
    new URL('/src/_assets/_game/_lion/jump/Jump_00027.png', import.meta.url).href,
    new URL('/src/_assets/_game/_lion/jump/Jump_00028.png', import.meta.url).href,
    new URL('/src/_assets/_game/_lion/jump/Jump_00029.png', import.meta.url).href,
    new URL('/src/_assets/_game/_lion/jump/Jump_00030.png', import.meta.url).href,
]

export const lionWalk = [
    // ------------------------ [ User Assets ] ---------
    new URL('/src/_assets/_game/_lion/walk/Walk_00000.png', import.meta.url).href,
    new URL('/src/_assets/_game/_lion/walk/Walk_00001.png', import.meta.url).href,
    new URL('/src/_assets/_game/_lion/walk/Walk_00002.png', import.meta.url).href,
    new URL('/src/_assets/_game/_lion/walk/Walk_00003.png', import.meta.url).href,
    new URL('/src/_assets/_game/_lion/walk/Walk_00004.png', import.meta.url).href,
    new URL('/src/_assets/_game/_lion/walk/Walk_00005.png', import.meta.url).href,
    new URL('/src/_assets/_game/_lion/walk/Walk_00006.png', import.meta.url).href,
    new URL('/src/_assets/_game/_lion/walk/Walk_00007.png', import.meta.url).href,
    new URL('/src/_assets/_game/_lion/walk/Walk_00008.png', import.meta.url).href,
    new URL('/src/_assets/_game/_lion/walk/Walk_00009.png', import.meta.url).href,
    new URL('/src/_assets/_game/_lion/walk/Walk_00010.png', import.meta.url).href,
    new URL('/src/_assets/_game/_lion/walk/Walk_00011.png', import.meta.url).href,
    new URL('/src/_assets/_game/_lion/walk/Walk_00012.png', import.meta.url).href,
    new URL('/src/_assets/_game/_lion/walk/Walk_00013.png', import.meta.url).href,
    new URL('/src/_assets/_game/_lion/walk/Walk_00014.png', import.meta.url).href,
    new URL('/src/_assets/_game/_lion/walk/Walk_00015.png', import.meta.url).href,
]

const IMAGECOUNT = 180;
export const lionRoar = new Promise<string[]>((resolve) => {
    let images: string[] = []
    for(let i = 0; i < IMAGECOUNT; i++) {
        if(i % 2 === 0) {
            let image = new URL(`/src/_assets/_game/_lion/roar/Roar_00${i.toString().padStart(3, '0')}.png`, import.meta.url).href
            images.push(image);
        }
    }
    resolve(images);
})